import { useEffect, useRef, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function MaquetteCRM() {
  const { user } = useAuth();
  const ref = useRef(null);
  const [src] = useState(`/crm/index.html${window.location.hash || "#accueil"}`);

  useEffect(() => {
    const frame = ref.current;
    if (!frame) return undefined;
    const versCadre = () => {
      const w = frame.contentWindow;
      if (w && window.location.hash && w.location.hash !== window.location.hash) w.location.hash = window.location.hash;
    };
    const auChargement = () => {
      frame.contentWindow.addEventListener("hashchange", () => {
        const h = frame.contentWindow.location.hash;
        if (h !== window.location.hash) window.history.replaceState(null, "", h);
      });
    };
    frame.addEventListener("load", auChargement);
    window.addEventListener("hashchange", versCadre);
    return () => { frame.removeEventListener("load", auChargement); window.removeEventListener("hashchange", versCadre); };
  }, []);

  if (user && user.role === "partenaire") return <Navigate to="/accueil-donnees" replace />;
  return (
    <iframe
      ref={ref}
      title="CRM Airthermo"
      src={src}
      data-testid="crm-maquette-frame"
      style={{ position: "fixed", inset: 0, width: "100vw", height: "100dvh", border: 0, display: "block" }}
    />
  );
}
